import { LoadingButton } from '@mui/lab';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  RESEND_SIGN_REQUEST_AMENDING_AGREEMENT,
  resendAmendingAgreementSingUrls
} from 'src/store/actions/contractActions';
import useStyles from './styles';

const ResendAmendingAgreementButton = ({
  contractId,
  buttonText = 'COMMON.RESEND_AMMENDING_AGREEMENT',
  ...rest
}) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loadingResendSignEmail = useSelector(
    isLoadingSelector([[RESEND_SIGN_REQUEST_AMENDING_AGREEMENT.action]])
  );

  const handleResendAmendingAgreement = useCallback(() => {
    dispatch(resendAmendingAgreementSingUrls(contractId));
  }, [contractId, dispatch]);

  return (
    <LoadingButton
      {...rest}
      variant="contained"
      color="primary"
      onClick={handleResendAmendingAgreement}
      loading={loadingResendSignEmail}
      loadingPosition="start"
      className={classes.buttons}
      startIcon={<RefreshIcon />}
    >
      {t(buttonText)}
    </LoadingButton>
  );
};

export default ResendAmendingAgreementButton;

ResendAmendingAgreementButton.propTypes = {
  contractId: PropTypes.string.isRequired,
  buttonText: PropTypes.string
};
